var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.initialized)?_c('div',[_c('MessageList',{attrs:{"hidePane":true}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }